<!--
 * @Author: liuc
 * @Date: 2023-04-12 10:26:23
 * @Description: 知识中心页面
-->
<template>
    <div class="box">
        <div class="left-box" id="mainContent">
            <div class="header">
                <img src="@/assets/images/xitongguanli.png" @click='handleOpen' alt="">
                <div class="dropdown-menu-box">
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            {{teamName}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleCommand(item)" v-for="item in tenantList" :key="item.id">{{item.teamName}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <!-- <img src="@/assets/images/guanbi.png" @click="handleQuit" alt=""> -->
                <span @click="handleQuit">退出</span>
            </div>
            <div class="problem-main" ref="scrollContainer" id="problemMain" v-scroll-to-bottom>
                <!--占位符-->
                <div class="loading-problem">
                    <img src="@/assets/images/img57.png" alt="">
                    <MarkdownPreview :initialValue="hint" />
                    <i class="el-icon-caret-left"></i>
                </div>
                <!--历史记录-->
                <div class="news" v-for="(item,index) in chatHistory[currentChat].chats" :key="index">
                    <div v-if="item.role === 'assistant' && item.content" class="chatpart">
                        <img src="@/assets/images/img57.png" alt="">
                        <MarkdownPreview :initialValue="item.content" :theme="theme" />
                        <i class="el-icon-caret-left"></i>
                        <i class="el-icon-delete-solid" v-if="!(typing || loading)" @click="removeChatPart(index)"></i>
                    </div>
                    <div v-else-if="item.role === 'user'" class="chatpart">
                        <img :src="userPicture || defaultAvatar" alt="">
                        <p :style="{ background: '#5599EC', color: '#FFFFFF'}">
                            {{ item.content }}
                        </p>
                        <i :style="{color: '#5599EC'}" class="el-icon-caret-left"></i>
                        <i class="el-icon-delete-solid" v-if="!(typing || loading)" @click="removeChatPart(index)"></i>
                    </div>
                </div>
                <!--输入效果-->
                <div v-if="typing" class="loading-problem">
                    <img src="@/assets/images/img57.png" alt="">
                    <MarkdownPreview v-if="current" :initialValue="current" />
                    <p v-else> <i class="el-icon-loading"></i></p>
                    <i class="el-icon-caret-left"></i>
                </div>
            </div>
            <div class="input_div">
                <el-input ref="textarea" type="textarea" maxlength="1000" show-word-limit placeholder="请输入您的问题"
                          :autosize="{ minRows: 1, maxRows: 2}" v-model="prompt" clearable resize=""
                          @keydown.ctrl.enter.native="submitClick">
                    <img slot="prefix" src="@/assets/images/submit.png" alt="">
                </el-input>
                <el-button v-loading="loading || typing" @click="submitClick" icon="el-icon-s-promotion"
                           :style="{ cursor: loading ? 'not-allowed' : 'pointer'}" element-loading-spinner="el-icon-loading"
                           element-loading-background="#e27373">
                </el-button>
                <el-button v-loading="loading || typing" @click="newChat" icon="el-icon-plus"
                           :style="{ cursor: loading ? 'not-allowed' : 'pointer'}" class="newChat"
                           element-loading-spinner="el-icon-loading" element-loading-background="#e27373">
                </el-button>
            </div>
        </div>
        <!-- 待操作 -->
        <div class="right-box" v-if="isData">
            <div class="title close-title">
                <span>模型选择</span>
                <!-- <span @click="close">X</span> -->
                <el-button icon="el-icon-close" type="text" @click="close"></el-button>
            </div>
            <div class="question">
                <el-checkbox-group v-model="modelUse" :min="1" :max="2">
                    <el-checkbox v-for="model in models" :label="model.model" :key="model.model" :disabled="!model.online">
                        {{ model.name }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="title">
                我可以作为您的
                <div>
                    <el-button icon="el-icon-refresh" @click="randomPick()">换一批</el-button>
                    <!-- <el-button icon="el-icon-plus" v-if="userInfo.manager" @click="addPrompt()">自定义</el-button> -->
                </div>
            </div>
            <div class="question">
                <div v-for="(item,index) in showPrompts" :key="index" @click="promptClick(item)">
                    <p>{{ item.title }}
                        <el-button type="text" icon="el-icon-delete" style="padding-left: 5px" v-if="item.id"
                                   @click="deletePrompt(item)">
                        </el-button>
                    </p>
                </div>
            </div>
            <div class="title">
                历史会话
                <!-- <div>
                    <el-button icon="el-icon-upload2" @click="uploadChats()">上传</el-button>
                    <el-button icon="el-icon-download" @click="downloadChats()">下载</el-button>
                </div> -->
            </div>
            <div class="question">
                <div v-for="(item,index) in chatHistory.slice().reverse()" :key="index"
                     @click="currentChat = chatHistory.length - 1 - index; isData = false; close()">
                    <p v-if="item.title">
                        {{ item.title }}<span v-if="item.time">{{ $parseDateTime(item.time) }}</span>
                        <el-button type="text" icon="el-icon-delete" style="padding-left: 5px" @click="deleteChat(index)">
                        </el-button>
                    </p>
                </div>
            </div>
        </div>
        <add-prompt ref="AddPrompt" @handleInputConfirm="handleAddPrompt"></add-prompt>

    </div>
</template>

<script>
import AddPrompt from '@/components/KnowledgeManagement/AddPrompt.vue';
import { MarkdownPreview } from 'vue-meditor';
import { mapState, mapMutations } from 'vuex';
// 购买资源包
const GPT3Tokenizer = require('gpt3-tokenizer').default;
export default {
    components: {
        MarkdownPreview,
        AddPrompt
    },
    data () {
        return {
            options: {
                position: 'bottom', // 'bottom' | 'center',
                duration: '3000'
            },
            isData: false,
            teamName: '请选择团队或公司', // 当前团队名称
            comPanyList: [], // 当前公司的列表
            subscribe: false, // 订阅
            ErrorVisible: false, // 警告弹框
            url: require('@/assets/images/img32.png'),
            msg: '',
            theme: 'dark',
            modelUse: ['gpt-3.5-turbo'],
            prompt: '',
            current: '',
            hotPrompts: [{
                hot: true,
                prompt: '',
                count: 0
            }],
            models: [{
                model: 'gpt-3.5-turbo',
                name: 'GPT3.5',
                online: true
            }, {
                model: 'gpt-4',
                name: 'GPT4',
                online: false
            }, {
                model: 'yiyan',
                name: '文心一言',
                online: false
            }, {
                model: 'adhoc',
                name: '式说',
                online: false
            }],
            typing: false, // ai输入状态
            loading: false, // 提交Loading
            abortLoading: false, // 终止生成loading
            ctrl: undefined,
            hint: '您好！我是小研，您可以试着在搜索栏输入您想问的问题',
            currentChat: 0, // 当前会话序号
            buildInPrompts: [{
                act: '智能助手', // ai充当角色
                prompt: '我是您的智能助手小研，我会响应您的提问。' // 提示词
            }],
            showPrompts: [{
                act: '智能助手',
                prompt: '我是您的智能助手小研，我会响应您的提问。'
            }],
            tokenLength: 0, // should limit to 4000 in one chat session
            chatHistory: [{
                title: '', // 会话标题
                token: 0, // 会话token
                time: '',
                chats: [
                    // {
                    // role: "user", // 会话角色 system/user/assistant
                    // content: "hello" // 对话内容
                    // }
                ]
            }],
            chat_session_key: '_chat_history_',
            apiUrl: 'https://chatwithx.cn/openai',
            // apiUrl: '/openai',
            // apiUrl: 'http://127.0.0.1:8081',
            tokenizer: new GPT3Tokenizer({ type: 'gpt3' })
        };
    },
    watch: {
        chatHistory: {
            deep: true,
            handler (val) {
                window.localStorage.setItem(this.chat_session_key, JSON.stringify(val));
            }
        }
    },
    computed: {
        ...mapState(['userPicture', 'userInfo', 'tenantList', 'defaultAvatar'])
    },
    async mounted () {
        this.comPanyList = this.tenantList;
        this.teamName = this.tenantList[0].teamName;
        // generate key
        this.chat_session_key = `_chat_history_${this.userInfo.id}_${this.userInfo.frontTenantId}_`;
        // 获取内建Prompt
        await this.getBuildInPrompts();
        // 加载历史记录
        this.chatHistory = JSON.parse(window.localStorage.getItem(this.chat_session_key));
        if (!this.chatHistory) {
            this.chatHistory = [];
        }
        if (this.chatHistory.length > 0) {
            this.currentChat = this.chatHistory.length - 1;
        } else {
            this.newChat();
        }
        let token = JSON.parse(window.sessionStorage.getItem('access_token'));
        const eventSource = new EventSource(`${this.apiUrl}/api/sse/${token}`, { withCredentials: true });
        eventSource.onopen = (event) => {
            console.debug(event);
        };
        eventSource.onmessage = (event) => {
            if (!this.typing) {
                this.typing = true;
            }
            try {
                if (event.data == '--OVER--') {
                    this.onChannelClose();
                } else {
                    const part = JSON.parse(event.data)['content'];
                    this.current = this.current + part;
                }
            } catch (error) {
                console.debug(error);
            }
        };
        eventSource.onerror = (error) => {
            console.log('error: ', error);
            this.typing = false;
            this.loading = false;
            this.current = '当前服务正忙，请稍后再试';
        };
    },
    methods: {
        /**
         * @author: zhaoxf
         * @description: 打开侧边栏
         */
        handleOpen () {
            this.isData = !this.isData;
            let box = document.getElementById('mainContent');
            let wrapper = document.createElement('div');
            wrapper.style.position = 'absolute';
            wrapper.style.top = 0;
            wrapper.style.left = 0;
            wrapper.style.height = '100%';
            wrapper.style.width = '100%';
            wrapper.style.background = '#00000030';
            wrapper.id = 'wrapper';
            box.appendChild(wrapper);
            let wrapperDom = document.getElementById('wrapper');
            wrapperDom.addEventListener('click', this.close);
        },
        close () {
            this.isData = false;
            let wrapperDom = document.getElementById('wrapper');
            wrapperDom.removeEventListener('click', this.close);
            let box = document.getElementById('mainContent');
            box.removeChild(wrapperDom);
        },
        /**
         * @author: zhaoxf
         * @description: 退出
         */
        handleQuit () {
            // 清除cookie
            document.cookie = `username=;expires=${-1}`;
            document.cookie = `password=;expires=${-1}`;
            window.sessionStorage.removeItem('access_token');
            this.$toast('已退出', this.options);
            this.$router.push({
                name: 'Login',
                path: '/login'
            });
        },
        /**
         * @author: liuc
         * @description: 租户团队下拉选择
         * @param {*} item
         */
        async handleCommand (item) {
            this.teamName = item.teamName;
            await this.$api.Common.switchTenant(item.id);
            let res = await this.$api.Common.current();
            this.$store.commit('setUserInfo', res.data);
            // mounted里内容
            // generate key
            this.chat_session_key = `_chat_history_${this.userInfo.id}_${this.userInfo.frontTenantId}_`;
            // 获取内建Prompt
            await this.getBuildInPrompts();
            // 加载历史记录
            this.chatHistory = JSON.parse(window.localStorage.getItem(this.chat_session_key));
            if (!this.chatHistory) {
                this.chatHistory = [];
            }
            if (this.chatHistory.length > 0) {
                this.currentChat = this.chatHistory.length - 1;
            } else {
                this.newChat();
            }
            let token = JSON.parse(window.sessionStorage.getItem('access_token'));
            const eventSource = new EventSource(`${this.apiUrl}/api/sse/${token}`, { withCredentials: true });
            eventSource.onopen = (event) => {
                console.debug(event);
            };
            eventSource.onmessage = (event) => {
                if (!this.typing) {
                    this.typing = true;
                }
                try {
                    if (event.data == '--OVER--') {
                        this.onChannelClose();
                    } else {
                        const part = JSON.parse(event.data)['content'];
                        this.current = this.current + part;
                    }
                } catch (error) {
                    console.debug(error);
                }
            };
            eventSource.onerror = (error) => {
                console.log('error: ', error);
                this.typing = false;
                this.loading = false;
                this.current = '当前服务正忙，请稍后再试';
            };
        },
        /**
         * 获取内建的Prompt
         * @author wenxiaopeng
         */
        async getBuildInPrompts () {
            const response = await this.$api.KnowledgeCenter.getPrompts(0, this.userInfo.frontTenantId);
            this.buildInPrompts = response.data;
            this.randomPick(false);
        },
        /**
         * 随机挑选10个Prompt显示在右侧
         * @author wenxiaopeng
         */
        async randomPick (random = true) {
            if (random) {
                this.showPrompts = [];
                while (this.showPrompts.length < 10) {
                    var index = Math.floor(Math.random() * this.buildInPrompts.length);
                    var element = this.buildInPrompts[index];
                    if (this.showPrompts.indexOf(element) === -1) {
                        this.showPrompts.push(element);
                    }
                }
            } else {
                this.showPrompts = this.buildInPrompts.slice(0, 10);
            }
        },
        /**
         * 上传聊天记录
         */
        async uploadChats () {
            if (this.chatHistory.length > 0) {
                if (!this.loading) {
                    this.loading = true;
                    let result = await this.$api.KnowledgeCenter.uploadChats(this.chatHistory);
                    if (result.code == 200) {

                    }
                    this.loading = false;
                }
            }
        },
        /**
         * 下载聊天记录
         */
        async downloadChats () {
            if (!this.loading) {
                this.loading = true;
                let chats = await this.$api.KnowledgeCenter.downloadChats();
                if (chats.code == 200) {
                    this.chatHistory = chats.data;
                }
                this.loading = false;
            }
        },
        /**
         * 新建会话
         * @author wenxiaopeng
         */
        newChat () {
            this.loading = true;
            if (this.chatHistory.length > 0 && this.chatHistory[this.chatHistory.length - 1].chats.length == 0) {
                this.chatHistory[this.chatHistory.length - 1].time = new Date().getTime();
            } else {
                this.chatHistory.push({
                    title: '', // 会话标题
                    token: 0, // 会话token
                    time: new Date().getTime(),
                    chats: []
                });
            }
            this.currentChat = this.chatHistory.length - 1;
            this.loading = false;
        },
        /**
         * 删除一条会话
         * @param {*} item  位置
         * @author wenxiaopeng
         */
        deleteChat (item) {
            const realIdx = this.chatHistory.length - 1 - item;
            this.chatHistory.splice(realIdx, 1);
            if (realIdx < this.currentChat) {
                this.currentChat = this.currentChat - 1;
            } else {
                if (this.chatHistory.length > 0) {
                    this.currentChat = this.currentChat - 1;
                } else {
                    // 仅有一个元素，删除后将没有元素
                    this.newChat();
                }
            }
        },
        /**
         * 移除一条对话
         * @param {*} index
         */
        removeChatPart (index) {
            this.chatHistory[this.currentChat].chats.splice(index, 1);
            let encode = this.tokenizer.encode(JSON.stringify(this.chatHistory[this.currentChat].chats));
            this.chatHistory[this.currentChat].token = encode.bpe.length;
        },
        /**
         * @author: zhangb
         * @description: 选择热门提问
         * @param {*} item
         */
        promptClick (item) {
            this.prompt = item.prompt;
            // 关闭侧拉
            this.isData = false;
            this.close();
        },
        /**
         * @author: zhangb
         * @description: 搜索问题
         */
        async submitClick () {
            if (this.loading || this.typing) {
                return false;
            }

            // 当前会话的token计数超过4000时开启新会话
            // 或超过20轮
            if (this.chatHistory[this.currentChat].token > 4000 || this.chatHistory[this.currentChat].chats.length > 20) {
                // this.$message.success('请开启新会话');
                // this.$refs.ErrorAlert.show(null, '本次会话长度已达上限，请删除部分对话，或开启新会话！', false, () => this.newChat(), null, null, '新会话');
                let options = {
                    yes: {
                        text: '新会话',
                        style: {}
                    },
                    no: {
                        text: '关闭',
                        style: {}
                    }
                };
                this.$confirm('本次会话长度已达上限，请删除部分对话，或开启新会话！', options).then(() => this.newChat()).catch();
                return;
            }

            if (this.prompt) {
                console.debug(`prompt: ${this.prompt}`);
                this.chatHistory[this.currentChat].chats.push({
                    content: this.prompt,
                    role: 'user'
                });
            } else {
                return false;
            }
            this.loading = true;

            // class MyError {
            //     constructor (code, msg) {
            //         this.code = code;
            //         this.msg = msg;
            //     }
            // }
            try {
                await this.$api.KnowledgeCenter.postChat(this.chatHistory[this.currentChat].chats);
                // 抛出指定异常
                // throw new MyError(30001, '管理员，请购买');
                // throw new MyError(30002, '非管理员');
                this.scrollToBottom();
            } catch (error) {
                if (error.code) {
                    this.current = error.msg;
                    // error.code == 30001 管理员，打开提示弹窗，话术：error.msg，选项：去购买/取消
                    // error.code == 30002 非管理员，打开提示弹窗，话术：error.msg，选项：关闭
                    switch (error.code) {
                    case 30001:
                        // this.$refs.ErrorAlert.show(null, this.current, false, () => this.buy(), null, null, '去购买');
                        this.$toast(this.current, this.options);
                        break;
                    case 30002:
                        // this.$refs.ErrorAlert.show(null, this.current, true);
                        this.$toast(this.current, this.options);
                    }
                } else {
                    this.current = '暂时无法响应您的问题，请稍后重试。';
                    // this.$refs.ErrorAlert.show(null, this.current, true);
                    this.$toast(this.current, this.options);
                }
                this.scrollToBottom();
                this.typing = false;
                this.loading = false;
                this.onChannelClose(false);
            }
        },
        /**
         * @author: zhaoxf
         * @description: 滚动到底部
         */
        scrollToBottom () {
            this.$nextTick(() => {
                var div = document.getElementById('problemMain');
                div.scrollTop = div.scrollHeight;
            });
        },
        ...mapMutations(['setSubscribeState']),
        /**
         * @author: zhaoxf
         * @description: 去购买
         */
        async buy () {
            this.subscribe = true;
            this.setSubscribeState(true);
            const resPackage = await this.$api.DevcorpWebsite.packages('function');
            let packageList = resPackage.data;
            this.$nextTick(() => {
                this.$refs.Subscribe.form.package = packageList[0];
                this.$refs.Subscribe.form.activeIndex = 1;
                this.$refs.Subscribe.packageList = packageList;
            });
            const resTenant = await this.$api.DevcorpWebsite.authTenant();
            let tenantList = resTenant.data.filter(item => {
                if (item.id == this.userInfo.frontTenantId) {
                    return item;
                }
            });
            this.$nextTick(() => {
                this.$refs.Subscribe.tenantList = tenantList;
                this.$refs.Subscribe.form.tenant = tenantList[0].id;
                this.$refs.Subscribe.current = tenantList[0];
                this.$refs.Subscribe.flag = 'subscribe';
                this.$refs.Subscribe.type = 2;
            });
        },
        /**
         * @author: zhaoxf
         * @description: 获取有权限的菜单
         */
        async getMenu () {
            const res = await this.$api.Common.listMenuByRoleId(this.userInfo.id, this.userInfo.frontTenantId, this.userInfo.userFlag);
            let navList = res.data.filter(item => item.menuType == 'L');
            let centerList = res.data.filter(item => item.menuType == 'R');
            this.$store.commit('setCenterList', centerList);
            this.$store.commit('setNavList', navList);
        },
        async onChannelClose (accounting = true) {
            console.debug(`${this.currentChat} closed`);
            this.typing = false;
            if (this.current) {
                this.chatHistory[this.currentChat].chats.push({
                    content: this.current,
                    role: 'assistant'
                });

                let encode = this.tokenizer.encode(JSON.stringify(this.chatHistory[this.currentChat].chats));
                this.chatHistory[this.currentChat].token = encode.bpe.length;
                if (accounting) {
                    if (!this.chatHistory[this.currentChat].title) {
                        // get summary of prompt
                        let summary = await this.$api.KnowledgeCenter.summaryPrompt(encodeURIComponent(this.chatHistory[this.currentChat].chats[0].content));
                        this.chatHistory[this.currentChat].title = summary.data.summary;
                        this.chatHistory[this.currentChat].id = summary.data.id;
                    }
                    await this.$api.KnowledgeCenter.accounting(encode.bpe.length);
                }
                this.prompt = '';
                this.current = '';
            }
            this.loading = false;
        },
        /**
         * abort request
         * @author wenxiaopeng
         */
        async abortRequest () {
            // console.debug('aborting');
            this.abortLoading = true;
            this.ctrl.abort();
            await this.onChannelClose();
            this.abortLoading = false;
        },
        /**
         * 打开新增提示词弹窗
         */
        addPrompt () {
            this.$refs.AddPrompt.onShow(this.userInfo.frontTenantId);
        },
        /**
         * 处理新增Prompt
         * @param {*} form
         */
        async handleAddPrompt (form) {
            let newPrompt = {};
            Object.assign(newPrompt, form);
            this.showPrompts.splice(0, 1, newPrompt);
        },
        deletePrompt (item) {
            this.$refs.ErrorAlert.show(null, '确定删除提示语？', false, async () => {
                await this.$api.KnowledgeCenter.deletePrompt(item.id);
                this.getBuildInPrompts();
            }, null, '删除后，租户成员也将无法继续使用', '删除');
        }

    }
};
</script>
<style lang="scss">
.el-message-box {
    width: 70%;
    .el-message-box__container {
        font-size: 16px;
    }
}
</style>
<style lang="scss" scoped>
.box {
    display: flex;
}
.left-box {
    position: relative;
    width: 100%;
    // margin-right: 15px;
    background: #f8f8f8;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
    .header {
        height: 55px;
        line-height: 55px;
        padding: 0 20px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        background: #eb5757;
        border-bottom: 1px solid #e2e5fa;
        align-items: center;
        display: flex;
        justify-content: space-between;

        // position: relative;
        // img {
        //     position: absolute;
        //     top: calc(50% - 10px);
        // }
        .dropdown-menu-box {
            text-align: center;
        }
        .el-dropdown {
            font-size: 16px;
            font-weight: 400;
            color: #fff;
        }
    }
    .problem-main {
        height: calc(100vh - 125px);
        overflow: auto;
        padding: 22px 20px 8px;
        position: relative;
        .news,
        .loading-problem {
            position: relative;
            display: flex;
            margin-bottom: 25px;
            img {
                width: 36px;
                height: 36px;
                vertical-align: top;
                margin-right: 20px;
            }
            p {
                display: inline-block;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                margin: 0;
                padding: 11px;
                line-height: 18px;
                background: #ffffff;
                box-shadow: 0px 4px 9px 1px rgba(79, 107, 255, 0.08);
                border-radius: 4px;
            }
            &:last-child {
                margin-bottom: 0;
            }
            /deep/ .markdown-preview {
                padding: 9px !important;
                border-radius: 4px;
                p {
                    margin: 0;
                }
            }
            /deep/ .el-icon-caret-left {
                position: absolute;
                top: 20px;
                left: 41px;
                transform: translateY(-50%);
                font-size: 24px;
                color: #fff;
            }
            /deep/ .el-icon-delete-solid {
                cursor: pointer;
                font-size: 16px;
                position: absolute;
                bottom: 0;
                right: -18px;
                color: #eb5757;
            }
        }
        .loading-problem {
            p {
                width: 125px;
                height: 36px;
                padding: 8px;
                text-align: center;
                background: #ffffff;
                box-shadow: 0px 4px 9px 1px rgba(79, 107, 255, 0.08);
                border-radius: 4px;
                .el-icon-loading {
                    font-size: 22px;
                }
            }
        }
    }
    .input_div {
        // position: absolute;
        display: flex;
        align-items: center;
        bottom: 15px;
        width: calc(100% - 40px);
        height: 70px;
        margin: 0 auto;
        img {
            margin-top: 4px;
        }
        /deep/ .el-textarea__inner {
            flex: 1;
            min-height: 50px !important;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            border-radius: 8px 0 0 8px;
            &::placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
        button {
            width: 10%;
            min-width: 50px;
            max-width: 80px;
            background: #ec5855;
            height: 50px;
            font-size: 16px;
            color: #fff;
            text-align: center;
            overflow: hidden;
            border-radius: 0px 8px 8px 0px;
            cursor: pointer;
        }
        button.newChat {
            width: 10%;
            border-radius: 8px;
        }
    }
}
.chatpart {
    display: flex;
    align-items: left;
    position: relative;
}
.right-box {
    width: 340px;
    height: 100vh;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(120, 111, 104, 0.1);
    border-radius: 8px 8px 0 0;
    overflow: auto;
    position: absolute;
    left: 0;
    z-index: 9999;
    .title {
        position: relative;
        font-size: 16px;
        color: #333333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &::before {
            content: "";
            width: 5px;
            height: 32px;
            background: url("~@/assets/images/img12.png") no-repeat;
            position: absolute;
            left: -20px;
            top: -3px;
        }
    }
    .close-title{
        display: flex;
        justify-content: space-between;
        .el-button {
            font-size: 22px;
        }
    }
    .question {
        & > div {
            display: flex;
            align-items: center;
            margin-bottom: 9px;
            &:first-child {
                margin-top: 18px;
            }
            &:last-child {
                margin-bottom: 25px;
            }
        }
        p {
            width: 300px;
            min-height: 38px;
            padding: 7px 12px;
            background: #f0f1f8;
            border-radius: 19px;
            font-size: 13px;
            color: #666666;
            cursor: pointer;
            &:hover {
                background: #e8ebff;
            }
            img {
                vertical-align: sub;
                margin-right: 6px;
                width: 20px;
            }
            span {
                color: #999999;
                margin-left: 8px;
            }
        }
        .el-checkbox {
            margin-right: 10px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ./src/views/KnowledgeCenter.vue